export const buildCheckTransportNumberArgs = (formData, matriculas, configTransport, packet) => {

    let outputArgs = {};
    const baseArgs = {
      Transportista: formData.nTransportista.value,
      Transport: formData.nTransporte.value,
      dniConductor: formData.dniConductor.value,
      nombreConductor: formData.nombreConductor.value,
      movilConductor: formData.movilConductor.value,
      matriculas,

    };
    outputArgs = baseArgs;
    console.log(baseArgs);
    // pasar a backend
    if(configTransport.albaran)
      outputArgs = { ...baseArgs, albaran: formData.albaran ? formData.albaran.value : null,};
    if(configTransport.pesoAlbaran)
      outputArgs = { ...outputArgs, pesoAlbaran: formData.pesoAlbaran ? formData.pesoAlbaran.value : null, };

    return {
        ...outputArgs,
        VBELN: packet?.VBELN ? packet.VBELN : null,
        EBELN: packet?.EBELN ? packet.EBELN : null,

    }

}


//VSART:  // si 07 no aparecen queueTypes
//KUNNR:  MTA, ONDA - 0000304265 - 0000302623 / 'pedido' // para pasar a las normas

//NOVAPET
/* export const fakeTransportSuccess =
{
  "TKNUM":"0003060926",
  "TDLNR":"0000018122",
  "STTRG":"1",
  "SHTYP":"ZM00",
  "ABFER":"2",
  "VSART":"10",
  "NAME1_T":"CISTERNAS Y TRANSPORTES BALLAR",
  "ORT01":"CAMPO",
  "STRAS":"C/ NUEVA 6",
  "REGIO":"22",
  "STCD1":"B22322424",
  "TPLST":"NOV1",
  "VBELN":"0083429449",
  "KUNNR":"0000304265",
  "NAME1":"TERMINAL INTERMODAL MONZON",
  "STRAS_WE":"POL. IND. ARMENTERA",
  "ORT01_WE":"MONZON",
  "REGIO_WE":"22",
  "NTGEW":"24000.0",
  "BRGEW":"24000.0",
  "RESWK":"NP01",
  "RESLO":"GR01",
  "WERKS":"NP01",
  "LGORT":"TI01",
  "MATNR":"000000000000400360",
  "ARKTX":"GB-2000 homopolimero Std Granel",
  "MAKTX":"GB-2000 homopolimero Std Granel",
  "LFIMG":"24000.0",
  "GEWEI":"KG",
  "INCO1":"CPT",
  "BSTKD":"4501269912",
  "STCEG_COMP":"ESA50996933",
  "NAME1_COMP":"NOVAPET S.A.",
  "CITY1_COMP":"ZARAGOZA",
  "POST_CODE1_COMP":"50001",
  "STREET_COMP":"PASEO INDEPENDENCIA, 21 6º",
  "CITY1_VSTEL":"Barbastro",
  "DPLBG":"2024-10-10",
  "UPLBG":"00:00:00",
  "DPREG":"2024-10-10",
  "DPABF":"2024-10-10",
  "DPTBG":"2024-10-10",
  "DPTEN":"2024-10-10",
  "XCHPF":"X",
  "LDDAT":"2024-10-10",
  "LFDAT":"2024-10-10",
  "KUNNR_VW":"00000000",
  "KOSTA":"A",
  "ADD01":"BARB_30T51",
  "DALBG":"0000-00-00",
  "UALBG":"00:00:00",
  "ROUTE":"TIM",
  "PIKMG":"0.0"
} */
  export const fakeTransportSuccess = {
  TKNUM: "0002535318",
  TDLNR: "0000018122",
  STTRG: "1",
  ABFER: "1",
  VSART: "06", // 07,08 activa Cisternas
  NAME1_T: "CISTERNAS Y TRANSPORTES BALLAR",
  ORT01: "CAMPO",
  STRAS: "C/ NUEVA 6",
  REGIO: "22",
  STCD1: "B22322424",
  TPLST: "NOV1",
  SHTYP: "ZT00",
  VBELN: "0083429413",
  KUNNR: "0000302623",
  NAME1: "NOVAPET, S.A.",
  STRAS_WE: "POL. IND. VALLE DEL CINCA",
  PSTLZ_WE: "22300",
  ORT01_WE: "BARBASTRO",
  REGIO_WE: "22",
  NTGEW: 0,
  BRGEW: 26500,
  RESWK: "NP01",
  WERKS: "NP01",
  LGORT: "TI01", // LGORT != MP01  activa SLOTS
  RESLO: "GR01",
  MATNR: "000000000000310001",
  ARKTX: "Acido tereftalico puro (PTA)",
  MAKTX: "Acido tereftalico puro (PTA)",
  LFIMG: "26500.0",
  GEWEI: "KG",
  INCO1: "CPT",
  INCO2: "Barbastro",
  BSTKD: "4501269892",
  STCEG_COMP: "ESA50996933",
  NAME1_COMP: "NOVAPET S.A.",
  CITY1_COMP: "ZARAGOZA",
  POST_CODE1_COMP: "50001",
  STREET_COMP: "PASEO INDEPENDENCIA, 21 6º",
  CITY1_VSTEL: "Monzón",
  DPLBG: "2024-08-01",
  UPLBG: "00:00:00",
  DPREG: "2024-08-01",
  DPABF: "2024-08-01",
  DPTBG: "2024-08-01",
  DPTEN: "2024-08-01",
  LDDAT: "2024-11-04",
  LFDAT: "2024-08-01",
  LDUHR: "17:00:00",
  IT_TEXTOS: {
    item: [
      {
        VBELN: "0083429413",
        ID: "0001",
      },
    ],
  },
  KUNNR_VW: "00000000",
  KOSTA: "A",
  ADD01: "BARB_PTA2",
  ADD02: "BARB_PTA2",
  DALBG: "0000-00-00",
  UALBG: "00:00:00",
  SIGNI: "asd123 qaz321",
  ROUTE: "TIM",
  PIKMG: "0.0",
  QR: "00025353180083429413",
  EXTI2: "a12345678",
  EXTI1: "test",
  ZZMOVIL: "987654321",
  loadPositions: [
    {
      TKNUM: "0002535318",
      BSTKD: "4501269892",
      VBELN: "0083429413",
      NTGEW: "0.0",
      BRGEW: "26500.0",
      MATNR: "000000000000310002",
      ARKTX: "Acido tereftalico puro (PTA)",
      MAKTX: "Acido tereftalico puro (PTA)",
      LFIMG: "26500.0",
      GEWEI: "KG",
      KUNNR: "0000304265",
      KOSTA: "A",
      NAME1: "NOVAPET, S.A.",
      STRAS_WE: "POL. IND. VALLE DEL CINCA",
      PSTLZ_WE: "22300",
      ORT01_WE: "none",
      REGIO_WE: "22",
    },
    {
      TKNUM: "0002535318",
      BSTKD: "4501269892",
      VBELN: "0083429413",
      NTGEW: "0.0",
      BRGEW: "26500.0",
      MATNR: "000000000000310003",
      ARKTX: "Acido tereftalico puro (PTA)",
      MAKTX: "Acido tereftalico puro (PTA)",
      LFIMG: "26500.0",
      GEWEI: "KG",
      KUNNR: "0000304265",
      KOSTA: "A",
      NAME1: "NOVAPET, S.A.",
      STRAS_WE: "POL. IND. VALLE DEL CINCA",
      PSTLZ_WE: "22300",
      ORT01_WE: "none",
      REGIO_WE: "22",
    },
  ],
}  

  //AGROTIM
/* export const fakeTransportSuccess = {
  TKNUM: "0003049412",
  TDLNR: "0000005411",
  STTRG: "1",
  ABFER: "1",
  VSART: "06",
  NAME1_T: "-",
  ORT01: "-",
  STRAS: "-",
  REGIO: "50",
  STCD1: "T11111111",
  TPLST: "TI02",
  VBELN: "0083416757",
  KUNNR: "0000115458",
  NAME1: "MAZANA PIENSOS COMPUESTOS, S.L",
  STRAS_WE: "CTRA. VALLE DE ARAN KM 5",
  PSTLZ_WE: "22480",
  ORT01_WE: "CAPELLA",
  REGIO_WE: "22",
  NTGEW: 27000,
  BRGEW: 27000,
  WERKS: "TI02",
  LGORT: "AG05",
  MATNR: "000000000030073779",
  ARKTX: "TRIGO FORRAJERO",
  MAKTX: "TRIGO FORRAJERO",
  LFIMG: "27000.0",
  GEWEI: "KG",
  INCO1: "EXW",
  STCEG_COMP: "ESB99264574",
  NAME1_COMP: "TERMINAL INTERMODAL MONZON,S.L.",
  CITY1_COMP: "ZARAGOZA",
  POST_CODE1_COMP: "50001",
  STREET_COMP: "PASEO INDEPENDENCIA, 21 3º",
  DPLBG: "2024-04-09",
  UPLBG: "00:00:00",
  DPREG: "2024-04-09",
  DPABF: "2024-04-09",
  DPTBG: "2024-04-09",
  DPTEN: "2024-04-09",
  LDDAT: "2024-04-09",
  LFDAT: "2024-04-09",
  KUNAG: "0000115458",
  KUNNR_VW: "00000000",
  KOSTA: "A",
  STCD1_KUNNR: "B22179774",
  DALBG: "0000-00-00",
  UALBG: "00:00:00",
  SIGNI: "ASD123 QAZ321",
  ROUTE: "TI2022",
  PIKMG: "27000.0",
  QR: "00030494120083416757",
  EXTI2: "A12345678",
  EXTI1: "Test",
  ZZMOVIL: "987654321",
  loadPositions: [
    {
      TKNUM: "0003049412",
      BSTKD: "--",
      VBELN: "0083416757",
      NTGEW: "27000.0",
      BRGEW: "27000.0",
      MATNR: "000000000030073779",
      ARKTX: "TRIGO FORRAJERO",
      MAKTX: "TRIGO FORRAJERO",
      LFIMG: "27000.0",
      GEWEI: "KG",
      KUNNR: "0000115458",
      KOSTA: "A",
      NAME1: "MAZANA PIENSOS COMPUESTOS, S.L",
      STRAS_WE: "CTRA. VALLE DE ARAN KM 5",
      PSTLZ_WE: "22480",
      ORT01_WE: "none",
      REGIO_WE: "22",
    },
  ],
} */
export const fakeTrasnportError = {
  root: {
    Envelope: {
      Body: {
        Fault: {
          Code: {
            Value: "env:Sender",
          },
          Reason: {
            Text: {
              $attributes: {
                lang: "en",
              },
              $value: "ERROR_TRANSPORTISTA",
            },
          },
          Detail: {
            "ZRFC_GET_SHIPPING_INFO.Exception": {
              Name: "ERROR_TRANSPORTISTA",
              Text: "Form of address key  is not defined",
              Message: {
                ID: "AM",
                Number: "117",
              },
            },
          },
        },
      },
    },
  },
  response: {
    statusCode: 500,
    body: "<env:Envelope xmlns:env=\"http://www.w3.org/2003/05/soap-envelope\"><env:Header/><env:Body><env:Fault><env:Code><env:Value>env:Sender</env:Value></env:Code><env:Reason><env:Text xml:lang=\"en\">ERROR_TRANSPORTISTA</env:Text></env:Reason><env:Detail><n0:ZRFC_GET_SHIPPING_INFO.Exception xmlns:n0=\"urn:sap-com:document:sap:rfc:functions\"><Name>ERROR_TRANSPORTISTA</Name><Text>Form of address key  is not defined</Text><Message><ID>AM</ID><Number>117</Number></Message></n0:ZRFC_GET_SHIPPING_INFO.Exception></env:Detail></env:Fault></env:Body></env:Envelope>",
    headers: {
      "set-cookie": [
        "sap-usercontext=sap-client=010; path=/",
      ],
      "content-type": "application/soap+xml; charset=utf-8",
      "content-length": "551",
      accept: "application/soap+xml",
      "sap-srt_id": "20240903/135559/v1.00_final_6.40/0050569094DC1EDF9ABD6F8128829FB3",
      connection: "close",
      "sap-perf-fesrec": "93115.000000",
    },
    request: {
      uri: {
        protocol: "http:",
        slashes: true,
        auth: null,
        host: "sapqas.samca.net:8001",
        port: "8001",
        hostname: "sapqas.samca.net",
        hash: null,
        search: null,
        query: null,
        pathname: "/sap/bc/srt/rfc/sap/zsrv_ws_master_sap/010/zsrv_ws_master_sap/zsrv_bn_shipping_info",
        path: "/sap/bc/srt/rfc/sap/zsrv_ws_master_sap/010/zsrv_ws_master_sap/zsrv_bn_shipping_info",
        href: "http://sapqas.samca.net:8001/sap/bc/srt/rfc/sap/zsrv_ws_master_sap/010/zsrv_ws_master_sap/zsrv_bn_shipping_info",
      },
      method: "POST",
      headers: {
        "User-Agent": "strong-soap/2.0.0",
        Accept: "text/html,application/xhtml+xml,application/xml,text/xml;q=0.9,*/*;q=0.8",
        "Accept-Encoding": "none",
        "Accept-Charset": "utf-8",
        Connection: "close",
        Host: "sapqas.samca.net:8001",
        "Content-Length": 373,
        "Content-Type": "application/soap+xml; charset=utf-8",
      },
    },
  },
  body: "<env:Envelope xmlns:env=\"http://www.w3.org/2003/05/soap-envelope\"><env:Header/><env:Body><env:Fault><env:Code><env:Value>env:Sender</env:Value></env:Code><env:Reason><env:Text xml:lang=\"en\">ERROR_TRANSPORTISTA</env:Text></env:Reason><env:Detail><n0:ZRFC_GET_SHIPPING_INFO.Exception xmlns:n0=\"urn:sap-com:document:sap:rfc:functions\"><Name>ERROR_TRANSPORTISTA</Name><Text>Form of address key  is not defined</Text><Message><ID>AM</ID><Number>117</Number></Message></n0:ZRFC_GET_SHIPPING_INFO.Exception></env:Detail></env:Fault></env:Body></env:Envelope>",
}
